/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_0_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_0_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app, the project and this website`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_0_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`区分应用、项目与本网站`)
};

/**
* | output |
* | --- |
* | "The app, the project and this website" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_0_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_0_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_0_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_0_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_0_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_0_title as "gc.search_guides.what_is_gridcraft.sections.0.title" }